// @ts-nocheck
import styled from 'styled-components';

export const ReportingShareReportLinkStyle = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  &.off {
    opacity: 0.7;
  }
  .sharedReportLink {
    &__copyLinkLabel {
      color: #c5cede;
      width: 100%;
      margin-right: 0.5rem;
      font-size: ${props => props.theme.fontSizeXS};
      white-space: nowrap;
      border-radius: 4px;
      border: solid 1px ${props => props.theme.contrastScaleMedium};
      padding: 8px 16px;
      cursor: default;
      user-select: none;
    }
    &__copyLink {
      margin-left: auto;
      > span:nth-child(2) {
        white-space: nowrap;
      }
    }
  }
`;
